export const SESSION_KEY = 'best2health_session_lk';
export const LANGUAGE_KEY = 'best2health_lang_lk';
